module.exports = __webpack_public_path__ + "img/rp_06.498dc1a0.jpg";